import { RequestConfig, RequestParams, useRequestImmer } from '../api/hooks';
import { EditorInfo, GMTInfo, Page } from './common';

export const SupplierEndpoint = `/supplier`;

/** 供应商 */
export interface Supplier extends GMTInfo, EditorInfo {
  id: number;

  /** 企业名 */
  name: string;

  /** 企业工商全称 */
  fullName: string;

  /**企业画廊 */
  poiId: number;

  /**备注 */
  memo?: string;

  /**联系电话 */
  tel?: string;

  /**地址 */
  address?: string;

  /**纬度 */
  latitude: string;

  /**经度 */
  longitude: string;

  paidAmount: number;
  totalAmount: number;
}

export enum SupplierLogTypeEnum {
  // 进货 预付款
  Purchase_Prepay = 1,
  // 对账
  Reconcile = 2,
  // 结算
  Settle = 4,
}

export const SupplierLogTypeDescMap = new Map<SupplierLogTypeEnum, string>([
  [SupplierLogTypeEnum.Purchase_Prepay, '进货预付款'],
  [SupplierLogTypeEnum.Reconcile, '对账'],
  [SupplierLogTypeEnum.Settle, '结算'],
]);

/** 供应商往来日志 */
export interface SupplierLog extends GMTInfo, EditorInfo {
  id: number;

  supplierId: number;

  type: SupplierLogTypeEnum;
  typeKey: string;

  amount: number;

  memo: string;
  addTime: string;
  creator: string;
}

export const useGetSupplierList = (config: RequestConfig = {}) => {
  return useRequestImmer<{
    list: Supplier[];
    page: Page;
  }>(
    {
      method: 'get',
      url: `${SupplierEndpoint}`,
    },
    {
      manual: true,
      ...config,
    }
  );
};

export const useGetSupplierLogList = (config: RequestConfig = {}) => {
  return useRequestImmer<{
    list: SupplierLog[];
    page: Page;
  }>(
    {
      method: 'get',
      url: `${SupplierEndpoint}/log/supplier/{supplierId}`,
    },
    {
      manual: true,
      ...config,
    }
  );
};

export const useGetSupplierLogListByTypeKey = (config: RequestConfig = {}) => {
  return useRequestImmer<SupplierLog[]>(
    {
      method: 'get',
      url: `${SupplierEndpoint}/log/typeKey/{typeKey}`,
    },
    {
      manual: true,
      ...config,
    }
  );
};
